import RequestSharedView from '../data/request'

export default class ApiSharedViewApp {

    static getSharedViewNew(publicKey:string, params:any = {}) {
        if (params.startDate)  params.startDate = gd.utils.momentToDate(params.startDate);
        if (params.endDate)    params.endDate = gd.utils.momentToDate(params.endDate);

        // @ts-ignore
        return new RequestSharedView(this, 'GET', publicKey, params, false)
    }


    getSharedView(publicKey:string, params:any = {}) {
        if (params.startDate)  params.startDate = gd.utils.momentToDate(params.startDate);
        if (params.endDate)    params.endDate = gd.utils.momentToDate(params.endDate);

        // @ts-ignore
        return new RequestSharedView(this, 'GET', publicKey, params);
    }

    getSharedData(publicKey:string, params:any = {}) {
        if (params.startDate)  params.startDate = gd.utils.momentToDate(params.startDate);
        if (params.endDate)    params.endDate = gd.utils.momentToDate(params.endDate);

        // @ts-ignore
        return new RequestSharedView(this, 'GET', publicKey+'/data', params);
    }

    getSharedDataPOST(publicKey:string, params:any = {}) {
        if (params.startDate)  params.startDate = gd.utils.momentToDate(params.startDate);
        if (params.endDate)    params.endDate = gd.utils.momentToDate(params.endDate);

        // @ts-ignore
        return new RequestSharedView(this, 'POST', publicKey+'/data', params);
    }

    getSharedDataWithFields(publicKey:string, systemStatus: any, fields = [], projectIds = []) {
        const params:any = {}
        if (systemStatus)   params.systemStatus = systemStatus
        if (projectIds)     params.projectIds = projectIds
        _.map(fields, field => params[field] = true)

        // @ts-ignore
        return new RequestSharedView(this, 'GET', publicKey+'/data', params);
    }


    // this is like getSharedDataWithFields but POST
    // we should use this one from now ! post is better
    // tut durackie params konechno ....
    viewData(publicKey:string, params:any={}, fields = []) {

        // if (systemStatus)   params.systemStatus = systemStatus
        // if (projectIds)     params.projectIds = projectIds

        // add fields
        _.map(fields, field => params[field] = true)

        // @ts-ignore
        return new RequestSharedView(this, 'POST', publicKey+'/data', params);
    }

    getSharedTaskData(publicKey:string, taskId: ID) {
        // @ts-ignore
        return new RequestSharedView(this, 'GET', publicKey+'/t/'+taskId);
    }

    getSharedDocData(publicKey:string, taskId: ID) {
        // @ts-ignore
        return new RequestSharedView(this, 'GET', publicKey+'/d/'+taskId);
    }

    getSharedExpensesData(publicKey:string, taskId: ID) {
        // @ts-ignore
        return new RequestSharedView(this, 'POST', publicKey+'/expenses/select',{
            taskIds : [taskId]
        })
    }
};